import React from "react";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import { Route } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import CustomLabel from '../../components/CustomFields/CustomLabel.jsx';
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'


const breadcrumbNameMap = {
    '/job-list': 'Job List',
    '/job-vendor-list': 'Job List',
    '/job-schedule': 'Job Schedule',
    '/job-schedule-list': 'Job Schedule List',
    '/live-tracking': 'Live Tracking',
    '/customers': 'Customers',
    '/report-transport-operation': 'Report',
    '/report-transport-operation-details': 'Report',
    '/report-customers': 'Report',
    '/report-customers-details': 'Report',
    '/vendor': 'Vendors',
    '/resources' : 'Resources',
    '/resources/transport-operator' : 'Transport Operator',
    '/resources/logistic-assistance' : 'Logistic Assistant',
    '/resources/vehicle' : 'Vehicle',
    '/jobs': 'Job List',
    '/jobs/route-optimize': 'Route Optimize',
    '/zones': 'Zone List',
    '/provider': 'Provider List',
};

const titleNameMap = {
    'dashboard' : 'List of available companies',
    'promotion': 'List of available promotions',
    'free-account': 'List of available free accounts',
    'charging-location-list': 'List of Charging Station Locations',
    'charging-location': 'Charging Station Locations',
    'provider': 'Providers',
}

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;


const BreadcrumbContainer = (props) => {
  return <Box clone className="breadcrumb-container">
            <Route>
            {({ location }) => {
            const pathnames = location.pathname.split('/').filter((x) => x);
            return <>
                <Grid item xs={(props && props.xs) ? props.xs : true}>
                <Breadcrumbs aria-label="breadcrumb">       
                {pathnames.map((value, index) => {
                    const last = index === pathnames.length - 1;
                    let to = `/${pathnames.slice(0, index + 1).join('/')}`;
                    if (to === '/jobs') to = '/job-list';

                    return last ? (
                    <Typography color="textPrimary" key={to}>
                        {breadcrumbNameMap[to]}
                    </Typography>
                    ) : (
                    <LinkRouter color="inherit" to={to} key={to}>
                        {breadcrumbNameMap[to]}
                    </LinkRouter>
                    );
                })}
                </Breadcrumbs>
                <CustomLabel
                    className={'no-margin'}
                    label={titleNameMap[pathnames.slice(-1)[0]]}
                    weight={'bold'}
                    size={'xl'}
                />
                </Grid>
            </>
            }}
    </Route>
  </Box>;
};


export default BreadcrumbContainer;
